<template>
  <b-select :value="localValue" @input="onInput" :expanded="expanded">
    <option v-for="(name, code) in countries" :key="code" :value="code">{{ name }}</option>
  </b-select>
</template>

<script>
import countries from "@/data/countries";

export default {
  props: ["expanded", "value"],

  data() {
    return {
      countries,
      localValue: this.value
    };
  },

  methods: {
    onInput(value) {
      this.localValue = value;
      this.$emit("input", value);
    }
  }
};
</script>
